import React from 'react'

import { Button, Form, Input, message, Modal} from 'antd'
import {toast} from 'react-toastify'
import { Buffer } from 'buffer';
import { useUpdateServiceMutation } from '../../../services/service/services.service'


export const EditCatagory = ({ visible, handleCancel, clients }) => {

    window.Buffer = Buffer;
    const [form] = Form.useForm();

    const [updateService, { data, isLoading, isSuccess, isError, error }] = useUpdateServiceMutation()

    if (isSuccess && data) {
        toast.success("User updated Successfully!")
        setTimeout(() => {
            handleCancel()
        }, 3000);
    }
    const valuesClient ={
        name: clients?.name,
        description: clients?.description,
    }

    const handleSubmit = (values) => {
        
        const id = clients.id
        const updateValues={
            name: values?.name,
            description: values?.description,
        }
        updateService({
            id,
            values:updateValues,
        })
    };

    const onFinishFailed = () => {
        message.error('Submit failed!');
    };

    return (
        <Modal
            visible={visible}
            title="Edit clients"
            onOk={form.submit}
            onCancel={handleCancel}
            className='client_modal_style'
            confirmLoading={isLoading}
        >
            {
                isError &&
                <div className='flex mt-3'>
                    <p className='text-red-500 text-md font-bold mx-3'>
                        {error?.name || error?.status}
                    </p>
                    <p className='text-red-500 text-md font-bold'>
                        {error?.message || error?.data.message}
                    </p>
                </div>
            }

            <Form
                form={form}
                layout="vertical"
                onFinish={handleSubmit}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                className='flex flex-col py-5 w-full'
                initialValues={valuesClient}
            >
                    <Form.Item
                        label="Catagory Name"
                        name="name"
                        rules={[
                            {
                                required: true,
                                message: 'Please input your Name!',
                            },
                        ]}
                    >
                        <Input type="text" />
                    </Form.Item>

                    <Form.Item
                        label="Description"
                        name="description"
                        rules={[
                            {
                                required: true,
                                message: 'Please input your description!',
                            },
                        ]}
                    >
                        <Input type="text" />
                    </Form.Item>
                    <Form.Item
                    >
                        <Button type="primary"
                        
                            htmlType="submit"
                            className='ant-btn-primary-login bg-green-600'
                            loading={isLoading}
                        >
                            Update
                        </Button>
                    </Form.Item>
            </Form>

        </Modal>
    )
}
